var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['meter_data'])?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/app/data/metering"}},[_c('fa-icon',{attrs:{"icon":"chart-area"}}),_vm._v(" Metering ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }